import React, { 
    useState,
    useEffect, 
} from 'react'
import {
    Row, 
    Col,
    Space,
} from "antd";
import { Modal } from "react-bootstrap";
import Logo from "../../Assets/Images/happyhippo-2.png"
import { numberFormat } from '../../Helpers/Utils/Common';

const OrderStatus = () => {
    const [openChangeModal, setOpenChangeModal] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({});
    const [totalPrice, setTotalPrice] = useState('');
    const [subTotalAmount, setSubTotalAmount] = useState('');
    const [computedDiscount, setComputedDiscount] = useState('');
    const [orderData, setOrderData] = useState([]);
     const [serviceCharge, setServiceCharge] = useState(0);
  
       useEffect(() => {
        const socket = new WebSocket(window.socket_ip);
        socket.onmessage = (event) => {
         if(event.data){
            let receivedData = event.data;
              const parsedData = JSON.parse(receivedData);
              if(parsedData?.menuCart){
                const order_data = parsedData.menuCart.map((data) => ({
                    counter: data.counter,
                    price: data.with_modifier === "1" ? data.with_modifier_total : data.price, 
                    name: data.name,
                    menu_modifier: data.addons,
                }))
                var total = order_data.reduce((sum, item) => sum + (item.price * item.counter),0)
                setTotalPrice(total)
                setOrderData(order_data);
              }

              if(parsedData?.changeData){
                setPaymentDetails(parsedData?.changeData);
              }

                setComputedDiscount(parsedData?.computedDiscount);

               if(parsedData?.grandTotal){
                setTotalPrice(parsedData?.grandTotal);
                setSubTotalAmount(parsedData?.subTotal);
              }


              if(parsedData?.serviceCharge !== undefined){
                    setServiceCharge(parsedData.serviceCharge);
                }

              if(parsedData?.openChangeModal){
                setOpenChangeModal(true);
              } else {
                setOpenChangeModal(false)
              }
            };
      
        }

        return () => {
          socket.close();
        };
    }, []);

    const calculatedSubTotal = orderData.reduce((sum, item) => {
        const price = parseFloat(item.price) || 0;
        const counter = parseInt(item.counter) || 0;
        return sum + (price * counter);
    }, 0);
    
    // Use subtotal from Payment component if available, otherwise calculate from orderData
    const subTotal = subTotalAmount || calculatedSubTotal;
    const finalTotal = totalPrice || (subTotal - computedDiscount + serviceCharge);


    const handleName = (item) => {
        return (
            <>
                <div>{item.name}</div>
                {item.menu_modifier && item.menu_modifier.map((data, index) => (
                    <Row key={index} className="ms-4">
                        {data?.modifier_name} - {data.price}
                    </Row>
                ))}
            </>
        );
    };
      
    return (
        <Row className='page-container'>
       <Col span={13} className="center">
                <img
                    src={Logo}
                    alt={"logo"}
                    className="login-logo"
                ></img>
            </Col>
            <Col span={11} className=''>
                <Row>
                    <Col 
                        span={24}
                        className='status-body'
                    >  
                        <Row className='px-4 mt-2'>
                            <Col 
                                span={12} 
                                className='status-header'
                            >
                                ORDER SUMMARY
                            </Col>
                            <Col 
                                span={12} 
                                className='status-header'
                                align="end"
                            >
                                <Space>
                                    <div>Total: </div>
                                    {finalTotal ? `₱ ${numberFormat(finalTotal)}` : 0}
                                </Space>
                            </Col>
                        </Row>
                      
                        <Row className='px-3 order-header'>
                            {/* <Col span={2} className='order-data' align="center">
                
                            </Col> */}
                            <Col span={4} className='order-data' align="center">
                                QTY
                            </Col>
                            <Col span={13} className='order-data' align="center">
                                NAME
                            </Col>
                            <Col span={7} className='order-data' align="right">
                                AMOUNT
                            </Col>
                        </Row>
                        <Row className='px-3 mt-2'>
                           <Col span={24} className='order-container'>
                                <Row>
                                    {
                                        orderData.map((item) => {
                                            return(
                                                <>
                                                    {/* <Col span={2} className='order-data' align="center">
                                                        •
                                                    </Col> */}
                                                    <Col span={4} className='order-data' align="center">
                                                        {`${item.counter}`}
                                                    </Col>
                                                    <Col span={13} className='order-data' align="left">
                                                        {handleName(item)}
                                                    </Col>
                                                    <Col span={7} className='order-data' align="right">
                                                        {`₱ ${numberFormat(parseFloat(item.price) * parseInt(item.counter))}`}
                                                    </Col>
                                                </>
                                            )
                                        })
                                    }
                                    {/* <ul>
                                        {messages.map((msg, index) => (
                                        <li key={index}>{msg}</li>
                                        ))}
                                    </ul> */}
                                </Row>
                            
                                <Modal
                                    size="lg"
                                    show={openChangeModal}
                                    onHide={() => setOpenChangeModal(false)}
                                    backdrop="static"
                                    keyboard={false}
                                    centered
                                >
                                    <Modal.Body className="bold-font">
                                        <Row>
                                            <Col span={24} className="mt-5" align='center'>
                                                <h1 className="subtitle pb-4">
                                                    CHANGE: ₱&nbsp;{paymentDetails.change}
                                                </h1>
                                            </Col>
                                        </Row>
                                        
                                    </Modal.Body>
                                </Modal>
                           </Col>
                        </Row>
                        {
                            computedDiscount && Object.keys(computedDiscount).length !== 0 && (
                                <>
                                    <Row className='px-4'>
                                        <Col 
                                            span={4} 
                                            className='sub-header'
                                        >

                                        </Col>
                                        <Col 
                                            span={20} 
                                            className='sub-header'
                                            align="end"
                                        >
                                            <Space>
                                                <div>Subtotal: </div>
                                                {subTotal ? `₱ ${numberFormat(subTotal)}` : 0}
                                            </Space>
                                        </Col>
                                    </Row>
                                        <Row className='px-4'>
                                    <Col 
                                        span={4} 
                                        className='sub-header'
                                    >
                                    </Col>
                                    <Col 
                                        span={20} 
                                        className='sub-header'
                                        align="end"
                                    >
                                        <Space>
                                            <div>Service Charge: </div>
                                            {serviceCharge ? `₱ ${numberFormat(serviceCharge)}` : 0}
                                        </Space>
                                    </Col>
                                </Row>
                                    <Row className='px-4'>
                                        <Col 
                                            span={4} 
                                            className='discount-header'
                                        >

                                        </Col>
                                        <Col 
                                            span={20} 
                                            className='discount-header'
                                            align="end"
                                        >
                                            <Space>
                                                <div>Discount: </div>
                                                {computedDiscount ? `₱ ${numberFormat(computedDiscount?.total_discount)}` : 0}
                                            </Space>
                                        </Col>
                                    </Row>
                                    <Row className='px-4'>
                                        <Col 
                                            span={4} 
                                            className='discount-header'
                                        >

                                        </Col>
                                        <Col 
                                            span={20} 
                                            className='discount-header'
                                            align="end"
                                        >
                                            <Space>
                                                <div>VAT Exemption: </div>
                                                {computedDiscount ? `₱ ${numberFormat(computedDiscount?.total_vat_exempt)}` : 0}
                                            </Space>
                                        </Col>
                                    </Row>
                                </>
                            )
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default OrderStatus